import { render, staticRenderFns } from "./TerminalItem.vue?vue&type=template&id=134b8243&scoped=true"
import script from "./TerminalItem.vue?vue&type=script&lang=js"
export * from "./TerminalItem.vue?vue&type=script&lang=js"
import style0 from "./TerminalItem.vue?vue&type=style&index=0&id=134b8243&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134b8243",
  null
  
)

export default component.exports